var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card',[_c('contents',[_c('product-title',[_vm._v(_vm._s(_vm.name))]),_c('paragraph',[_vm._v(_vm._s(_vm.description))])],1),_c('div',[_c('styled-button',{attrs:{"href":_vm.link.url,"target":"_blank"}},[_c('button-text',[_vm._v(_vm._s(_vm.link.name))]),_c('i',{staticClass:"fas fa-arrow-right"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }